/**
 * Provides JS functionality for featured media cta.
 */
class FeaturedMediaCta extends DrupalBehavior {

  onReady(context) {
    // Prevent open video when slider it's swiped.
    document.querySelectorAll('.featured-media-cta__media-wrap').forEach((element) => {
      element.addEventListener('click', function (e) {
        if($(element).parents('.slick-initialized').hasClass('block-video-open')) {
          e.stopImmediatePropagation();
        }
      }, true);
    });
    $('.featured-media-cta__media-button').each(function () {
      $(this).modalVideo({
        channel: $(this).attr('data-video-provider')
      });
    });
  }

}

DrupalBehavior.register('camc.components', 'featuredMediaCta', FeaturedMediaCta);
